





















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class GalleryList extends Vue {
  @Prop({ required: true }) images!: string[];
  @Prop({ required: false }) title?: string;
  @Prop({ required: false, default: false }) blur?: boolean;

  lightboxActive = false;
  lightboxImage: string | null = null;

  closeLightbox() {
    this.lightboxActive = false;
  }
  openLightbox(image: string) {
    this.lightboxImage = image;
    this.lightboxActive = true;
  }
  url(image: string) {
    return `/assets/${image}`;
  }
}
